import {
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    customUpdateOpenTradeAccount,
    OpenTradeDataResultModel,
    UpdateOTAParameter,
} from "@tSurya/Services/SubmitOpenTradeService";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<any & HasOnSuccess<OpenTradeDataResultModel>, OpenTradeDataResultModel>;

export const DispatchBeginSubmitOpenTrade: HandlerType = props => {
    props.dispatch({
        type: "Custom/UpdateOpenTradeData/BeginUpdateOpenTrade",
    });
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await customUpdateOpenTradeAccount(props.apiParameter);
};

export const DispatchCompleteSubmitOpenTrade: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/UpdateOpenTradeData/CompletedUpdateOpenTrade",
        result: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter?.onSuccess?.(props.apiResult);
};

export const chain = [
    DispatchBeginSubmitOpenTrade,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteSubmitOpenTrade,
    ExecuteOnSuccessCallback,
];

const loadUpdateOpenTradeData = createHandlerChainRunner(chain, "loadUpdateOpenTradeData");
export default loadUpdateOpenTradeData;
